import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const Tooltip = (props) => {

  return (
    <>
      <Tippy content={props.tooltip} interactive={true} placement="bottom">
        {props.children}
      </Tippy>
    </>
  );
};


export default Tooltip;